var _defs, _path, _polygon, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProjectsGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#7F7F7F;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7F7F",
    d: "M42.03223,3a3.0034,3.0034,0,0,1,3,3V42a3.0034,3.0034,0,0,1-3,3h-36a3.0034,3.0034,0,0,1-3-3V6a3.0034,3.0034,0,0,1,3-3h36m0-3h-36a6.01765,6.01765,0,0,0-6,6V42a6.01765,6.01765,0,0,0,6,6h36a6.01765,6.01765,0,0,0,6-6V6a6.01765,6.01765,0,0,0-6-6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.85 9.907 25.85 12.966 23.85 15.743 8.85 15.743 8.85 9.907 23.85 9.907"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.85 33.907 40.85 36.966 38.85 39.743 23.85 39.743 23.85 33.907 38.85 33.907"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.85 21.907 39.85 24.966 37.85 27.743 12.85 27.743 12.85 21.907 37.85 21.907"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectsGrey);
export default __webpack_public_path__ + "static/media/icon-projects-grey.0d8a682156ce06f5eb9093d4885f326c.svg";
export { ForwardRef as ReactComponent };